import {Modal, useMemo, useState} from 'external/react'

import useAuth from 'context/auth-context/hook'
import usePayment from 'context/payment-context/hook'

import { paymentService } from 'services/payment.service'
import { notifyError } from 'components/Notify'
import ModalAcceptCancelFooter from 'components/ModalAcceptCancelFooter'

export default function PaymentButton () {

    const {showLogin, user} = useAuth()
    const {packageItem, cart} = usePayment()
    const [confirmationOpened, setConfirmationShow] = useState(false)

    const [hasPackage, item] = useMemo(() => [!!packageItem, packageItem || {}], [packageItem])

    const {paymentTotal} = item as any 

    async function handlePayment() {
        if (!user) {
            showLogin()
        } else {
            //handlePaymentStripe(cart, paymentTotal)
            setConfirmationShow(true)
        }
    }

    async function handleConfirmation() {
        handlePaymentStripe(cart, paymentTotal)
    }

    async function handleCloseConfirmation() {
        setConfirmationShow(false)
    }
    
    const disabled = useMemo(() => {
        if (paymentTotal <= 0) return true
        if (cart.properties.basicExtra.findIndex(b => b === false) >= 0) return true
        return false
    }, [paymentTotal, cart.properties])

    return (
       <div className='card-footer text-muted bg-white'>
           {hasPackage && (
                <button className='btn btn-primary w-100' onClick={handlePayment} disabled={disabled} >
                    Pagar $ {paymentTotal.toFixed(2)}
               </button>
           )}
			<Modal show={confirmationOpened} onHide={handleCloseConfirmation} size='lg' centered>
				<Modal.Header closeButton>
					<h5 className='text-capitalize' style={{ fontFamily: 'Arial, sans-serif', margin: '0' }} >
						Atención
					</h5>
				</Modal.Header>
				<Modal.Body>
                    <p style={{marginBottom: "16px; line-height: 1.5;"}}>
                      Todos los pagos de suscripción son finales y no reembolsables.
                    </p>
                    <p style={{marginBottom: "5px; line-height: 1.5;"}}>
                      No se concederán reembolsos ni créditos por períodos parciales, servicios no utilizados o cancelaciones anticipadas.
                   </p>
                    <p style={{marginBottom: "5px; line-height: 1.5;"}}>
                      Al completar su compra, usted acepta estos términos.
                    </p>
				</Modal.Body>
				<ModalAcceptCancelFooter onCancel={handleCloseConfirmation} onAccept={handleConfirmation}/>
			</Modal>

    </div>
   )
}

async function handlePaymentStripe({id, client}, displayedTotal) {
    const purchase = { id, client, displayedTotal}
    const response = await paymentService.completePurchase(purchase);
    if (response.data.data.url) {
        window.location.href = response.data.data.url
    } else {
        notifyError('Ocurrió un error durante el comienzo del pago.')
    }
};